import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initSentry } from './utils/monitoring';
import { initGlobalDateTimeFormatter } from './utils/dateTimeFormatter';

// Initialize global date/time overrides
initGlobalDateTimeFormatter();

// Initialize error monitoring (safe — no-op if Sentry not configured)
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// ── Service Worker Registration (Offline POS Support) ────────
if ('serviceWorker' in navigator) {
    if (process.env.NODE_ENV === 'production') {
        window.addEventListener('load', () => {
            navigator.serviceWorker
                .register('/service-worker.js')
                .then((reg) => {
                    console.log('[DFood] Service Worker registered:', reg.scope);
                })
                .catch((err) => {
                    console.log('[DFood] Service Worker registration failed:', err);
                });
        });
    } else {
        // Automatically unregister active service workers in development to prevent caching issues
        navigator.serviceWorker.getRegistrations().then((registrations) => {
            for (let registration of registrations) {
                registration.unregister().then((success) => {
                    if (success) {
                        console.log('[DFood] Unregistered active service worker in development');
                        window.location.reload();
                    }
                });
            }
        });
    }
}


